import React from 'react';
import './styles/clean.css';

const PageLayout = ({ title, icon = '', subtitle = '', children }) => (
  <div className="clean-page">
    <nav className="clean-nav">
      <a href="/" className="clean-nav__home">
        ← longloop.xyz
      </a>
      <span className="clean-nav__sep">/</span>
      <span className="clean-nav__title">{title}</span>
    </nav>

    <main className="clean-main">
      <div className="clean-page-header">
        <h1 className="clean-page-title">
          {icon && <span style={{ marginRight: 8 }}>{icon}</span>}
          {title}
        </h1>
        {subtitle && <p className="clean-page-subtitle">{subtitle}</p>}
      </div>
      {children}
    </main>

    <footer className="clean-footer">
      longloop.xyz &nbsp;·&nbsp; <a href="/">home</a> &nbsp;·&nbsp; no tracking
    </footer>
  </div>
);

export default PageLayout;
